










































import Vue from "vue";
import Blob from "./Blob.vue";
import { mdiPalette } from "@mdi/js";

export const AppHeader = Vue.extend({
  name: "AppHeader",
  components: { Blob },
  props: {
    BaseHue: Number,
    ComplementaryHue: Number,
  },
  data: () => ({
    PaletteIcon: mdiPalette,
    paths: [
      "M59.6,-42.2C71.9,-32.1,72.9,-7.6,68,16.1C63,39.8,52.1,62.7,35.4,69C18.8,75.3,-3.8,64.9,-22.9,53.4C-42,41.9,-57.8,29.4,-61.5,13.8C-65.2,-1.7,-56.8,-20.2,-44.6,-30.2C-32.3,-40.3,-16.2,-41.9,3.7,-44.9C23.6,-47.9,47.3,-52.2,59.6,-42.2Z",
      "M58.9,-48.4C66.4,-37.5,55.7,-13.6,49.5,10.3C43.2,34.2,41.4,58.2,30.7,63C20.1,67.8,0.6,53.5,-12.4,41.3C-25.4,29.1,-31.9,18.9,-39.4,3.9C-46.9,-11.1,-55.3,-31,-48.9,-41.6C-42.5,-52.3,-21.3,-53.7,2.2,-55.5C25.7,-57.2,51.4,-59.3,58.9,-48.4Z",
      "M43.8,-32.8C59.5,-15.2,76.8,3.1,73.6,16.6C70.3,30.1,46.6,38.7,24.4,48.7C2.1,58.7,-18.5,70,-37.7,65.6C-56.8,61.2,-74.4,41.1,-80.8,17.2C-87.2,-6.6,-82.4,-34.3,-67.1,-51.7C-51.8,-69.2,-25.9,-76.4,-5.9,-71.7C14,-67,28.1,-50.3,43.8,-32.8Z",
      "M45.1,-32C59.7,-17.7,73.6,1.1,71,17.8C68.5,34.4,49.5,48.9,28.2,59.6C6.9,70.2,-16.8,77.1,-30.3,68.4C-43.8,59.8,-47.2,35.7,-50.2,13.9C-53.2,-7.9,-55.9,-27.3,-47.5,-40.2C-39,-53.1,-19.5,-59.6,-2.1,-57.9C15.3,-56.2,30.6,-46.4,45.1,-32Z",
      "M35.8,-50.4C50.4,-38.7,69.1,-33.6,79,-21.3C88.9,-9.1,90.1,10.3,84.3,27.2C78.5,44,65.7,58.4,50.5,67.5C35.2,76.6,17.6,80.5,2.6,76.9C-12.5,73.4,-25,62.5,-40,53.3C-55.1,44.2,-72.8,36.8,-80.3,23.8C-87.7,10.7,-84.9,-8,-78.3,-24.6C-71.7,-41.2,-61.4,-55.8,-47.7,-67.8C-34.1,-79.8,-17,-89.2,-3.2,-84.8C10.6,-80.3,21.2,-62.1,35.8,-50.4Z",
      "M59.1,-45.8C66.3,-38.2,54.5,-14.2,47.4,8.2C40.2,30.7,37.6,51.6,25.4,60.4C13.2,69.2,-8.5,65.9,-24.8,56.2C-41.1,46.5,-52.1,30.5,-59.5,10.2C-66.8,-10.1,-70.5,-34.6,-60,-43.1C-49.4,-51.5,-24.7,-43.8,0.6,-44.3C26,-44.8,52,-53.5,59.1,-45.8Z",
      "M26.1,-27.5C31.7,-13.8,32.8,-3,31.9,9.8C31,22.6,28.1,37.5,18.3,44.8C8.5,52.2,-8.2,51.9,-27.4,46.6C-46.6,41.3,-68.3,30.9,-67.6,19.6C-66.9,8.2,-43.7,-4.1,-28.7,-20C-13.7,-35.9,-6.8,-55.3,1.7,-56.7C10.2,-58,20.5,-41.3,26.1,-27.5Z",
      "M59.5,-50.7C71.3,-32.8,70.9,-8.3,66.1,16.1C61.3,40.6,52.3,65.1,35,74C17.6,82.9,-7.9,76.1,-22.7,62.9C-37.6,49.7,-41.8,30.1,-44.9,11.7C-48,-6.8,-50,-24.1,-42.3,-41.1C-34.6,-58.1,-17.3,-74.8,3.3,-77.5C23.9,-80.1,47.8,-68.6,59.5,-50.7Z",
      "M47.1,-44.1C54.7,-28,50.2,-8.8,46.2,11.3C42.2,31.4,38.7,52.3,25,63.4C11.2,74.5,-12.9,75.7,-32.1,66.5C-51.2,57.3,-65.4,37.8,-71.4,15.2C-77.3,-7.3,-75.1,-32.7,-61.8,-50.1C-48.6,-67.6,-24.3,-77,-2.3,-75.2C19.7,-73.4,39.5,-60.3,47.1,-44.1Z",
      "M31,-25.6C45.1,-7,64.9,6.1,67,22.6C69.1,39.1,53.5,58.9,32.2,70.6C10.8,82.4,-16.2,86.1,-33.7,75.6C-51.3,65,-59.3,40.2,-56.2,21.9C-53.2,3.6,-39,-8.1,-27.8,-26C-16.6,-44,-8.3,-68,0.1,-68.1C8.5,-68.2,16.9,-44.2,31,-25.6Z",
      "M36.4,-31.8C42.2,-21.7,38.5,-6.9,33.1,3.9C27.7,14.6,20.6,21.2,8.2,33.5C-4.1,45.8,-21.7,63.7,-34.8,61.5C-47.9,59.3,-56.5,37.1,-54.5,19.9C-52.5,2.7,-39.9,-9.5,-29,-20.8C-18.2,-32,-9.1,-42.3,3.1,-44.8C15.3,-47.3,30.6,-41.9,36.4,-31.8Z",
      "M28.3,-25.4C41.5,-5.9,60.5,6.1,62.1,20.1C63.6,34.2,47.7,50.1,30.2,56C12.7,61.9,-6.5,57.7,-17.6,48C-28.6,38.2,-31.6,23.1,-33.5,9.2C-35.5,-4.8,-36.6,-17.4,-30.8,-35.1C-25.1,-52.9,-12.5,-75.7,-2.5,-73.7C7.5,-71.7,15,-44.9,28.3,-25.4Z",
      "M62.5,-40.7C78.1,-30.3,85.8,-4.5,78.5,14C71.2,32.6,48.8,43.8,29.7,47.6C10.6,51.4,-5.4,47.8,-24.2,41.9C-43,36,-64.8,27.9,-72.6,11.4C-80.5,-5,-74.5,-29.8,-60,-39.9C-45.6,-50,-22.8,-45.5,0.3,-45.7C23.5,-46,46.9,-51.1,62.5,-40.7Z",
      "M65.4,-45.7C78.9,-35.3,79.8,-8.4,70.3,9.1C60.8,26.6,40.7,34.8,23.9,38.6C7.1,42.5,-6.4,42,-26.1,38.5C-45.8,35.1,-71.6,28.7,-76.3,15.3C-81.1,2,-64.6,-18.2,-48.4,-29.3C-32.2,-40.4,-16.1,-42.4,4.9,-46.4C26,-50.3,51.9,-56.2,65.4,-45.7Z",
      "M41.7,-35.4C53.9,-18,63.5,-0.7,62.1,17.8C60.8,36.3,48.6,55.9,31.2,63.8C13.9,71.8,-8.6,68.2,-29.3,58.9C-50,49.7,-68.9,34.9,-70.7,18.5C-72.5,2.2,-57.2,-15.6,-42.6,-33.6C-28,-51.6,-14,-69.7,0.4,-70.1C14.8,-70.4,29.6,-52.9,41.7,-35.4Z",
      "M57.8,-45.3C70.6,-30.1,73.5,-6.3,68,14.6C62.5,35.6,48.6,53.7,32.5,57.6C16.5,61.6,-1.7,51.3,-15,41.1C-28.3,30.9,-36.8,20.6,-44,5.4C-51.2,-9.9,-57.1,-30.1,-49.6,-44C-42,-58,-21,-65.7,0.8,-66.3C22.5,-66.9,45.1,-60.4,57.8,-45.3Z",
      "M33.5,-27.4C48.7,-7.7,69.9,6.6,69.2,18.2C68.5,29.8,45.8,38.9,27.3,42.2C8.8,45.6,-5.4,43.3,-24.4,38.7C-43.4,34.2,-67,27.4,-75,11.6C-83,-4.1,-75.2,-29,-60.1,-48.7C-45,-68.4,-22.5,-83,-6.7,-77.7C9.2,-72.3,18.4,-47.1,33.5,-27.4Z",
      "M49.4,-34.9C65,-19.8,79.4,0.8,74.3,14.4C69.2,28.1,44.5,34.7,23.4,42.5C2.3,50.3,-15.2,59.3,-29.7,54.9C-44.2,50.6,-55.5,32.9,-57.2,15.8C-58.9,-1.3,-50.9,-17.8,-39.8,-31.8C-28.7,-45.9,-14.3,-57.5,1.3,-58.5C16.9,-59.5,33.8,-49.9,49.4,-34.9Z",
      "M29.1,-16.5C44.8,-3.5,69.6,9,71.1,21.8C72.7,34.6,50.9,47.6,29.2,56.4C7.5,65.2,-14.1,69.8,-23.7,60.8C-33.3,51.7,-30.8,29.1,-37.1,6.8C-43.5,-15.4,-58.9,-37.3,-54.2,-47.8C-49.5,-58.4,-24.7,-57.5,-9,-50.3C6.7,-43.1,13.3,-29.5,29.1,-16.5Z",
      "M24.4,-24C33.2,-8.3,43.2,1.9,44.5,15.7C45.7,29.4,38.2,46.7,25.1,53.6C11.9,60.5,-6.9,57,-19.3,48C-31.8,39,-37.7,24.5,-45.4,6C-53.1,-12.5,-62.7,-35,-55.4,-50.3C-48.1,-65.6,-24.1,-73.7,-8.1,-67.2C7.8,-60.7,15.5,-39.6,24.4,-24Z",
      "M32.6,-36.5C36.7,-20.8,30.7,-7.6,29.1,9.4C27.4,26.4,30.1,47.2,21,56.6C11.8,66.1,-9.1,64.1,-25.4,55.3C-41.8,46.4,-53.6,30.7,-58.7,12.2C-63.9,-6.2,-62.3,-27.3,-51.4,-44.5C-40.5,-61.8,-20.3,-75.1,-3,-72.7C14.2,-70.3,28.4,-52.1,32.6,-36.5Z",
      "M38.7,-30.1C50.2,-16.4,59.8,-0.3,57.2,13.8C54.5,27.9,39.8,40,25.2,43.8C10.6,47.6,-4,43.1,-23.8,37.9C-43.6,32.8,-68.7,27.1,-72.8,14.9C-76.9,2.8,-60,-15.8,-44.4,-30.5C-28.8,-45.2,-14.4,-55.9,-0.4,-55.6C13.6,-55.3,27.2,-43.9,38.7,-30.1Z",
      "M31,-28.4C43.5,-9.1,59.2,4,59.8,18.7C60.4,33.4,46.1,49.6,27.6,59.4C9,69.2,-13.7,72.5,-28.5,63.6C-43.2,54.8,-50,33.9,-53.8,13.4C-57.6,-7.1,-58.3,-27.1,-48.9,-45.7C-39.4,-64.4,-19.7,-81.6,-5.2,-77.4C9.3,-73.3,18.6,-47.7,31,-28.4Z",
    ],
    blobStyles: [
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
      { top: 0, left: 0 },
    ],
  }),
  computed: {
    HeaderStyle: function() {
      return {
        backgroundColor: `hsl(${this.BaseHue},80%,70%)`,
      };
    },
    TitleStyle: function() {
      return {
        textDecoration: "underline",
        textDecorationColor: `hsl(${this.ComplementaryHue},70%,70%)`,
      };
    },
  },
  created() {
    this.updateBlobStyles();
    setInterval(this.updateBlobStyles, 20000);
  },
  methods: {
    updateBlobStyles(): void {
      let newStyles = [];
      for (let i = 0; i < this.blobStyles.length; i++) {
        newStyles.push(this.getRandomBlobStyle());
      }
      this.blobStyles = newStyles;
    },
    getRandomBlobStyle(): { left: string; top: string } {
      // top/left position of
      // const top = `${50 + Math.round(Math.random() * 30)}%`;
      // const left = `${-10 + Math.round(Math.random() * 120)}%`;
      const posX = Math.random() < 0.5;
      const posY = Math.random() < 0.5;
      const x = Math.round(Math.random() * 10);
      const left = posX ? `-${x}%` : `${100 + x}%`;
      const y = Math.round(Math.random() * 10);
      const top = posY ? `-${y}%` : `${100 + y}%`;

      return { left, top };
    },
    getRandomPath() {
      return this.paths[Math.floor(Math.random() * this.paths.length)];
    },
  },
});

export default AppHeader;
